import { Body1 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import theme from '@flatsy/core/MuiTheme/theme'
import clsx from 'clsx'
import React from 'react'
import { formatCandidatRef } from 'src/utils/FormatCandidatRef'
import { applicantsList } from 'src/utils/GetApplicantsListOrFalse'
import useStyles from './Style'
import { ComponentsProps } from './Type'

const UserStepper: React.FC<ComponentsProps> = ({ applicants, hide, currentApplicantId }) => {
  const classes = useStyles()
  if (hide || !applicants || applicants.length === 0) {
    return null
  }

  const isActive = (applicant: applicantsList) => {
    if (applicant.id === currentApplicantId) {
      return true
    }

    return false
  }

  return (
    <div className={clsx(classes.container, hide && classes.containerRemove)}>
      {!hide &&
        applicants.map((applicant, key) => (
          <div className={clsx(classes.line, isActive(applicant) && classes.lineActive)}>
            <Body1
              fontColor={
                isActive(applicant) ? theme.palette.primary.dark : theme.palette.secondary.main
              }
            >
              {applicant.first_name ? `${applicant.first_name}` : formatCandidatRef(applicant, key)}
            </Body1>
            {applicant.lead && (
              <img src={FlatsyTheme.image.crown} className={classes.crown} alt="lead" />
            )}
          </div>
        ))}
    </div>
  )
}

export default UserStepper
